// extracted by mini-css-extract-plugin
export default {"DisplayOptions":"ImageDisplayOptions_DisplayOptions__NyjuB"};